import {
  FileOutlined,
  UploadOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { selectors as authSelectors } from '@hixme/auth-ui'
import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import { Space, Tag, Tooltip, Typography } from 'antd'
import dayjs from 'dayjs'
import React from 'react'
import { useSelector } from 'react-redux'
import { CensusFileDto } from '../api/dto/census-file.dto'

const { Text, Link } = Typography

function FileInfo({
  data,
  clientName,
  style,
}: {
  style?: any
  data: CensusFileDto | undefined
  clientName: string
}) {
  const {
    rowCount = '...',
    fileName = '...',
    createdAt: uploadDateTime,
    presignedDownloadUrl,
    companyIgnoredFields,
  } = data ?? {}
  const pastDate = dayjs(uploadDateTime)
  const now = dayjs()
  const lastModified = uploadDateTime ? pastDate.from(now) : '...'
  const userRole = useSelector(authSelectors.getRole)
  const isSurecoAdmin = userRole === ROLE_PLATFORM_HIXME_ADMIN
  return (
    <>
      <Space direction="vertical" size="small" style={style}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Text strong style={{ fontSize: '24px' }}>
            {clientName}{' '}
            <span style={{ color: '#b0b0b0' }}>({rowCount} Records)</span>
          </Text>
          {isSurecoAdmin &&
          companyIgnoredFields &&
          companyIgnoredFields.length > 0 ? (
            <Tooltip
              title={
                <>
                  <div>This customer is configured to ignore these fields:</div>
                  <ul style={{ margin: '4px 0', paddingLeft: '20px' }}>
                    {companyIgnoredFields.map((field) => (
                      <li key={field}>{field}</li>
                    ))}
                  </ul>
                  <div>
                    New records are not affected by this ignore setting.
                  </div>
                </>
              }
            >
              <Tag color="warning" icon={<WarningOutlined />}>
                Ignore Changes Fields ({companyIgnoredFields.length})
              </Tag>
            </Tooltip>
          ) : null}
        </div>
        <div
          style={{ color: '#b0b0b0', display: 'flex', alignItems: 'center' }}
        >
          <FileOutlined style={{ fontSize: '14px', marginRight: '8px' }} />
          {presignedDownloadUrl ? (
            <Link
              href={presignedDownloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#b0b0b0' }}
            >
              {fileName}
            </Link>
          ) : (
            <Text>{fileName}</Text>
          )}
        </div>
        <div
          style={{ color: '#b0b0b0', display: 'flex', alignItems: 'center' }}
        >
          <UploadOutlined style={{ fontSize: '14px', marginRight: '8px' }} />
          <Text>{lastModified}</Text>
        </div>
      </Space>
    </>
  )
}

export default FileInfo
